import { useActionState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { State, addLoadType } from "../actions";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import FormError from "../../../../components/form-error";
import { Button } from "../../../../components/button";

export default function ExerciseLoadTypeCreateForm(){
    const navigate = useNavigate();
    const initialState: State = {
        message: null,
        success: false,
        errors: {},
        defaultValues: {
            name: "",
        },
    };

    const [state, formAction, isPending] = useActionState(
        addLoadType,
        initialState
    );
    useEffect(() => {
        if (state.success) {
            navigate("/admin/exercise-load-types");
        }
    }, [state]);

    return (
        <form className="space-y-6 max-w-xl py-8 text-left" action={formAction}>
            <FormBody>
                <div className="mb-4">
                    <Label htmlFor="name">Name</Label>
                    <Input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Enter load type name"
                        aria-describedby="name-error"
                        defaultValue={state.defaultValues?.name ?? ""}
                        required
                    />
                    <FormError id="name-error" message={state.errors?.name} />
                </div>
                 <div className="mb-4">
                    <Label htmlFor="name">Order Number</Label>
                    <Input
                        id="orderNumber"
                        name="orderNumber"
                        type="number"
                        step="1"
                        min={1}
                        placeholder="Enter order number"
                        aria-describedby="orderNumber-error"
                        defaultValue={state.defaultValues?.orderNumber ?? ""}
                        required
                    />
                    <FormError id="orderNumber-error" message={state.errors?.orderNumber} />
                </div>
                 
            </FormBody>
            <div className="mt-6 flex justify-end gap-4">
                <Link to="/admin/exercise-load-types">
                    <Button type="reset" disabled={isPending}>
                        Cancel
                    </Button>
                </Link>
                <Button
                    type="submit"
                    disabled={isPending}
                    loading={isPending}
                    className="min-w-[90px]"
                >
                    Save Changes
                </Button>
            </div>
        </form>
    );
}